import { render, staticRenderFns } from "./batchDeployIms.vue?vue&type=template&id=5ecb8883&"
import script from "./batchDeployIms.vue?vue&type=script&lang=js&"
export * from "./batchDeployIms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports